import { atom } from "jotai";

export interface IHeaderV2ContentStore {
  title?: string;
}

export const headerV2ContentStoreInitialState: IHeaderV2ContentStore = {};

export const HeaderV2ContentStore = atom(headerV2ContentStoreInitialState);
